@let err = error();

<ideal-error-card>
  <ideal-error-title>{{ err.title }}</ideal-error-title>
  <ideal-error-message class="pad-bottom">Access to {{ err.url }} has been denied.</ideal-error-message>
  <ideal-error-message class="pad-bottom">{{ err.message }}</ideal-error-message>
  <button mat-flat-button routerLink="/my-account/accounts">Click here to add an account number</button>
</ideal-error-card>
